import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSizeSetApplied.meta';

export type UseTrackSizeSetAppliedParams = {
  size_set_id: string;
  member_count: number;
  source: 'canvas_picker';
};

export const useTrackSizeSetApplied = () => {
  const { track } = useAnalyticsUtilities();

  const trackSizeSetApplied = useCallback(
    (params: UseTrackSizeSetAppliedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSizeSetApplied };
};
